/* eslint-disable */
import api from '@/services/api';

export default {
  async fetchDespesasImportacao({ commit, dispatch }, filtros) {
    const params = new URLSearchParams();
    for (const key of Object.keys(filtros)) {
      if (filtros[key]) {
        params.append(key, filtros[key]);
      }
    }
    dispatch('toggleLoading', true, { root: true });
    const response = await api.get('/processo/despesasImportacao/', { params });
    commit('SET_LISTA_DESPESAS_IMPORTACAO', response.data.data);
    commit('paginacao/SET_PAGINADOR', response.data, { root: true });
    dispatch('toggleLoading', false, { root: true });
  },
  async filtrar({ commit }, payload) {
    commit('SET_FILTROS', payload);
  },

  async prepararExcelDespesasImportacaoProcesso(_, payload) {
      const keys = Object.keys(payload);
      const params = new URLSearchParams();
      for (const key of keys) {
        if (payload[key]) {
          params.append(key, payload[key]);
        }
      }
      const { data } = await api.get('/processo/despesasImportacao/excel', { params });
      if (!data) return null;
      const excelFormatado = data.map((infoDist) => ({
        referenciaCliente: infoDist.referenciaCliente,
        referenciaTrust: infoDist.referenciaTrust,
        dataChegada: infoDist.dataChegada,
        dataAberturaProcesso: infoDist.dataAberturaProcesso,
        modalidadeImportacao: infoDist.modalidadeImportacao,
        codigoDI: infoDist.codigoDI,
        dataRegistroDI: infoDist.dataRegistroDI,
        modalidadeTransporte: infoDist.modalidadeTransporte,
        canalParametrizacao: infoDist.canalParametrizacao,
        exportador: infoDist.exportador,
        dataEmbarque: infoDist.dataEmbarque,
        dataChegada: infoDist.dataChegada,
        paisOrigem: infoDist.paisOrigem,
        paisDestino: infoDist.paisDestino,
        descricaoCurta: infoDist.descricaoCurta,
        quantidade: infoDist.quantidade,
        valorUnitario: infoDist.valorUnitario,
        valorUnitarioNegociado: infoDist.valorUnitarioNegociado,
        valorFreteInternacionalReal: infoDist.valorFreteInternacionalReal,
        valorSeguroInternacionalDolar: infoDist.valorSeguroInternacionalDolar,
        valorSeguroInternacionalReal: infoDist.valorSeguroInternacionalReal,
        valorII: infoDist.valorII,
        valorCIF: infoDist.valorCIF,
        valorPIS: infoDist.valorPIS,
        valorCOFINS: infoDist.valorCOFINS,
        outrasDespesas: infoDist.outrasDespesas,
        moedaFreteIntl: infoDist.moedaFreteIntl,
        valorTotalNFe: infoDist.valorTotalNFe,
        valorArmazenagem: infoDist.valorArmazenagem,
        outrasDespesas: infoDist.outrasDespesas,
        freteNacional: infoDist.freteNacional,
        totalDespesas: infoDist.totalDespesas,
        valorTotalFaturado: infoDist.valorTotalFaturado,
        valorDescComercial: infoDist.valorDescComercial,
        baseCalculoImpostoImportacao: infoDist.baseCalculoImpostoImportacao,
        siscomex: infoDist.siscomex,
        baseCalculoIPI: infoDist.baseCalculoIPI,
        dataRegistroCanalParametrizacao: infoDist.dataRegistroCanalParametrizacao,
        dataFaturamento: infoDist.dataFaturamento,
        valorFOBUnitarioMoeda: infoDist.valorFOBUnitarioMoeda,
        valorFOBUnitarioReal: infoDist.valorFOBUnitarioReal,
        moedaInvoice: infoDist.moedaInvoice,
        valorFOBTotalReal: infoDist.valorFOBTotalReal,
        AliqIIPorcentagem: infoDist.aliqIIPorcentagem,
        AliqIPIPorcentagem: infoDist.aliqIPIPorcentagem,
        AliqPISPorcentagem: infoDist.aliqPISPorcentagem,
        AliqCOFINSPorcentagem: infoDist.aliqCOFINSPorcentagem,
        codigoDocFiscalSaida: infoDist.codigoDocFiscalSaida,
      }));
      return excelFormatado;
    }
};
